import * as React from "react";
export function SvgNarrowSortArrowDescending(
  props: React.SVGProps<SVGSVGElement>
): JSX.Element {
  return (
    <svg viewBox="0 0 9 19" {...props}>
      <path fill="#333" d="M5 10V5H4v5H2.5l2 3.6 2-3.6z" />
    </svg>
  );
}
